import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/parameters/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/parametersModel.js
// module id = 10
// module chunks = 0